import { render, staticRenderFns } from "./AskAnswerLogPage.vue?vue&type=template&id=2815c7e9&scoped=true&"
import script from "./AskAnswerLogPage.vue?vue&type=script&lang=js&"
export * from "./AskAnswerLogPage.vue?vue&type=script&lang=js&"
import style0 from "./AskAnswerLogPage.vue?vue&type=style&index=0&id=2815c7e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2815c7e9",
  null
  
)

export default component.exports